import React, { useEffect } from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { ZoInputText } from '../zo-input-text-temp/zo-input-text-temp';
import { SVGS } from '../assets';
import Button from '@mui/material/Button';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import './signup-gst-details.scss';
import { SellerDetails } from '@zonofi/zo-types';
import { JTBDEventType, useEventTracking } from '@zonofi/seller-rtk-store';

interface SignUpGSTDetailsProps {
  setShowWithoutGstin: () => void;
  sellerDetails: SellerDetails;
  onUpdateValue: (key: string, value: string) => void;
  validateGST: () => void;
  isValidatingGST: boolean;
  gstErrorMessage?: string;
}

export const SignUpGSTDetails: React.FC<SignUpGSTDetailsProps> = ({
  setShowWithoutGstin,
  sellerDetails,
  onUpdateValue,
  validateGST,
  isValidatingGST,
  gstErrorMessage,
}) => {
  const { trackEvent } = useEventTracking();
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        validateGST();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [validateGST]);
  return (
    <SignUpContainer>
      <div className="gstin_screen">
        <div className="gstintop_sec">
          <span className="primary-font-semibold heading">
            Speed Up Your ZöTok Setup
          </span>
          <span className="primary-font-regular seller-font-size-medium sub-heading">
            Enter your GSTIN to quickly verify your business details.
          </span>
        </div>
        <div className="gstin_screen_sec">
          <div>
            <ZoInputText
              title={'GST Number'}
              name={'gstin'}
              required={true}
              value={sellerDetails?.gstin}
              onBlur={() => {}}
              focusInput={true}
              inputFieldProps={{
                name: 'gstin',
                placeholder: 'Provide your GST Number',
                value: sellerDetails?.gstin,
                onChange: (e: { target: { value: string } }) => {
                  const regex = /^[0-9A-Za-z]{0,15}$/;
                  if (regex.test(e.target.value)) {
                    onUpdateValue('gstin', e.target.value?.toUpperCase());
                  }
                },
                maxLength: 15,
              }}
              error={!!gstErrorMessage}
              endAdornment={
                <span
                  className="text-gray-500"
                  style={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: '#8c8c8c',
                  }}
                >
                  {sellerDetails?.gstin?.length}/15{' '}
                </span>
              }
            />
            {gstErrorMessage && (
              <div className="gstErrorMsg">
                <img
                  src={SVGS.ErrorIcon}
                  width={16}
                  height={16}
                  className="ErrorIcon"
                />
                {gstErrorMessage}
              </div>
            )}
          </div>
          <div
            style={{
              color: '#262626',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '20px',
            }}
          >
            How this helps you:
          </div>
          <div
            style={{
              color: '#262626',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              marginBottom: 32,
            }}
          >
            <div>✓ Auto-fills company name, address & business type</div>
            <div>✓ Reduces setup time from 5 minutes to 30 seconds</div>
            <div>✓ Provide most relevant information to your customer</div>
          </div>

          <ZoButton
            onClick={validateGST}
            isLoading={isValidatingGST}
            label={'Validate GSTIN'}
            className="sign-up-now-btn primary-font-semibold"
            disabled={sellerDetails?.gstin?.length !== 15}
          />
          <span className="dontGstin primary-font-semibold">
            <Button
              className="fillform"
              variant="text"
              onClick={() => {
                onUpdateValue('gstin', '');
                setShowWithoutGstin();
                trackEvent(JTBDEventType.SIGNUP_GSTIN_NOT_PROVIDED, {
                  ...sellerDetails,
                });
              }}
            >
              <span className="primary-font-regular text-btn">
                I don't have GSTIN
              </span>
              <img
                src={SVGS.RightArrow}
                width={16}
                height={16}
                className="rightarrow"
              />
            </Button>
          </span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '16px',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          alignSelf: 'stretch',
          borderRadius: 8,
          background: '#E6F0FF',
          maxWidth: 470,
          boxSizing: 'border-box',
        }}
      >
        {/* <span
          style={{
            color: '#595959',
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
          }}
        ></span>{' '} */}
        <span
          style={{
            color: '#595959',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
          }}
        >
          Your privacy matters: We only use GSTIN to fetch basic company details
          for your convenience. This information stays secure with us and is
          never shared externally or reported anywhere.
        </span>
      </div>
      {/* <span className="primary-font-regular seller-font-size-regular gst-text">
        We only use GSTIN to fetch your business info for a faster seller
        account <br />
        setup. Your data is protected with industry-standard encryption and will{' '}
        <br />
        never be shared or leaked.
      </span> */}
    </SignUpContainer>
  );
};
